import _classCallCheck from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/rgvnews-2020/rgvnews.com/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/es6.object.assign";
import { COMMON_LEGEND_PROPERTY_INDEX } from '../../legend';
import { keys } from '../../util';
import { Split } from '../split';
var LEGEND_COMPONENT_PROPERTY_INDEX = Object.assign(Object.assign({}, COMMON_LEGEND_PROPERTY_INDEX), {
  disable: 1,
  labelExpr: 1,
  selections: 1,
  // channel scales
  opacity: 1,
  shape: 1,
  stroke: 1,
  fill: 1,
  size: 1,
  strokeWidth: 1,
  strokeDash: 1,
  // encode
  encode: 1
});
export var LEGEND_COMPONENT_PROPERTIES = keys(LEGEND_COMPONENT_PROPERTY_INDEX);
export var LegendComponent =
/*#__PURE__*/
function (_Split) {
  _inherits(LegendComponent, _Split);

  function LegendComponent() {
    _classCallCheck(this, LegendComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(LegendComponent).apply(this, arguments));
  }

  return LegendComponent;
}(Split);